export function swipersInit() {

    const swiperBanners = new Swiper('.swiper-banners', {
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
        watchOverflow: true,
        speed: 700,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        navigation: {
          nextEl: '.swiper-button-next.banner-next',
          prevEl: '.swiper-button-prev.banner-prev',
        },
        pagination: {
          el: '.swiper-pagination.banners',
          type: "progressbar",
        },
      });

    const highlightsCategoriesSwiper = new Swiper('.categories-swiper', {
        slidesPerView: 1,
        spaceBetween: 15,
        watchOverflow: true,
        navigation: {
          nextEl: '.swiper-button-next.categories-next',
          prevEl: '.swiper-button-prev.categories-prev',
        },
        pagination: {
          el: '.swiper-pagination.categories',
          clickable: true
        },
        breakpoints: {
          576: {
            slidesPerView: 2,
            spaceBetween: 15,
          },
          992: {
            slidesPerView: 4,
            spaceBetween: 15,
          },
        }
      });

      const searchedCarsSwiper = new Swiper('.searched-cars-swiper', {
        slidesPerView: 1,
        spaceBetween: 15,
        watchOverflow: true,
        navigation: {
          nextEl: '.swiper-button-next.searched-cars-next',
          prevEl: '.swiper-button-prev.searched-cars-prev',
        },
        breakpoints: {
          576: {
            slidesPerView: 2,
            spaceBetween: 15,
          },
          992: {
            slidesPerView: 4,
            spaceBetween: 15,
          },
        }
      });

      
      const institutionalSwiper = new Swiper('.institutional-swiper', {
        slidesPerView: 1,
        spaceBetween: 15,
        watchOverflow: true,
        navigation: {
          nextEl: '.swiper-button-next.institutional-next',
          prevEl: '.swiper-button-prev.institutional-prev',
        },
        pagination: {
          el: '.swiper-pagination.institutional',
          clickable: true,
          dynamicBullets: true,
          dynamicMainBullets: 3,
        },
      });

      const swiperBlogInternalRelated = new Swiper('.blog-internal-related-slider', {
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
        slidesPerView: 1,
        watchOverflow: true,
        watchOverflow :true,
        navigation: {
          nextEl: '.swiper-button-next.blog-internal',
          prevEl: '.swiper-button-prev.blog-internal',
        },
        pagination: {
          el: '.swiper-pagination.blog-internal',
          clickable: true
        },
        breakpoints: {
          800: {
            slidesPerView: 3,
            spaceBetween: 15,
          },
          992: {
            slidesPerView: 4,
            spaceBetween: 15,
          },
        }
      });

      const swiperUsedModelInternalThumbs = new Swiper('.seminovos-detalhe-slider-thumbs', {
        slidesPerView: 4,
        freeMode: true,
        spaceBetween: 20,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        navigation: {
          nextEl: '.swiper-button-next.seminovos-slider-thumbs',
          prevEl: '.swiper-button-prev.seminovos-slider-thumbs',
        },
        breakpoints: {
          992: {
            slidesPerView: 4,
            spaceBetween: 16,
          }
        }
      });
    
      const usedModelInternalSwiper = new Swiper('.seminovos-detalhe-slider', {
        slidesPerView: 1,
        navigation: {
          nextEl: '.swiper-button-next.seminovos-slider',
          prevEl: '.swiper-button-prev.seminovos-slider',
        },
        clickable: true,
        thumbs: {
          swiper: swiperUsedModelInternalThumbs,
        },
      });

      const usedRelatedSwiper = new Swiper('.used-related-swiper', {
        slidesPerView: 1,
        spaceBetween: 15,
        watchOverflow: true,
        navigation: {
          nextEl: '.swiper-button-next.used-related-next',
          prevEl: '.swiper-button-prev.used-related-prev',
        },
        breakpoints: {
          992: {
            slidesPerView: 3,
            spaceBetween: 15,
          },
          1400: {
            slidesPerView: 4,
            spaceBetween: 15,
          },
        }
      });


}